<template>
    <div id="pre-trial-notice" class="pb-10">
        <v-expansion-panels flat>
            <v-expansion-panel>
                <v-expansion-panel-header class="pa-0" hide-actions>
                    <template v-slot:default="{ open }">
                        <div class="d-flex align-center">
                            <div class="text-subtitle-1 font-weight-bold gray--text">Фильтр</div>
                            <v-icon color="gray" v-if="open">arrow_drop_up</v-icon>
                            <v-icon color="gray" v-if="!open">arrow_drop_down</v-icon>
                        </div>
                    </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="v-row">
                    <v-row>
                        <v-col>
                            <v-text-field :label="nameLabel" color="gray" append-icon="search" outlined v-model="filter.name" class="v-col-2" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="8">
                            <v-text-field
                                hide-spin-buttons
                                type="number"
                                color="gray"
                                append-icon="search"
                                outlined
                                v-model.number="filter.main_dolg"
                                label="Сумму долга по основным услугам, выше которой необходимо найти должника "
                            />
                        </v-col>
                        <v-col>
                            <v-text-field
                                color="gray"
                                type="number"
                                hide-spin-buttons
                                :label="serialNumberLabel"
                                append-icon="search"
                                outlined
                                v-model.number="filter.serial_number"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <AddressSelector v-model="filter.selectedAddress" ref="addressSelector">
                                <v-text-field
                                    color="gray"
                                    append-icon="arrow_drop_down"
                                    placeholder="Выберите адрес"
                                    class="pointer"
                                    outlined
                                    readonly
                                    hide-details
                                    clearable
                                    v-model="filter.selectedAddress.address_full_name"
                                ></v-text-field>
                            </AddressSelector>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3">
                            <PreTrialDatePicker label="Дата создания документа" :is-range="true" :date.sync="filter.doc_create_date" />
                        </v-col>
                        <v-col cols="3">
                            <PreTrialDatePicker label="Дата вручения документа" :is-range="true" :date.sync="filter.doc_delivery_date" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <div>Документ подписан:</div>
                            <v-radio-group row v-model="filter.doc_signed">
                                <v-radio
                                    color="gray"
                                    v-for="signStatus in signingStatuses"
                                    :key="signStatus.label"
                                    :label="signStatus.label"
                                    :value="signStatus.value"
                                ></v-radio
                            ></v-radio-group>
                        </v-col>
                    </v-row>
                    <v-row v-if="!isAccounts">
                        <v-col>
                            <div>Уведомление вручено:</div>
                            <v-radio-group row v-model="filter.doc_delivered">
                                <v-radio
                                    color="gray"
                                    v-for="delivery in PreTrialDelivery"
                                    :key="delivery.label"
                                    :label="delivery.label"
                                    :value="delivery.value"
                                ></v-radio
                            ></v-radio-group>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-btn color="white" outlined @click="resetFilter" class="mr-10 gray--text">Сбросить</v-btn>
                            <v-btn color="gray" class="white--text" @click="applyFilter">Применить</v-btn>
                        </v-col>
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
import AddressSelector from '@/components/administration/AddressSelector.vue';
import PreTrialDatePicker from '@/components/pre-trial-notices/PreTrialDatePicker.vue';

export default {
    name: 'PreTrialFilter',
    components: { PreTrialDatePicker, AddressSelector },
    props: {
        filterModel: {
            required: true
        },
        isAccounts: {
            required: false,
            default: false,
            type: Boolean
        }
    },
    computed: {
        filter: {
            get() {
                return this.filterModel;
            },
            set(value) {
                this.$emit('update:filterModel', value);
            }
        },
        nameLabel() {
            return this.isAccounts ? 'ФИО по лицевому счету' : 'Наименование контрагента';
        },
        serialNumberLabel() {
            return this.isAccounts ? 'Номер лицевого счета' : 'Номер договора ';
        }
    },
    data: function() {
        return {
            signingStatuses: [
                { label: 'Отображать все', value: 2 },
                { label: 'Подписан', value: 1 },
                { label: 'Не подписан', value: 0 }
            ],
            PreTrialDelivery: [
                { label: 'Отображать все', value: 2 },
                { label: 'Вручено', value: 1 },
                { label: 'Не вручено', value: 0 }
            ],
            menu: false,
            date: null
        };
    },
    methods: {
        applyFilter() {
            this.$emit('applyFilter');
        },
        resetFilter() {
            this.$emit('resetFilter');
        }
    }
};
</script>

<style>
#pre-trial-notice .v-expansion-panel-content__wrap {
    padding: 0;
}
</style>
